import api from './api'

/**
 * 兼容多层包装：
 * { list }
 * { code, data: { list } }
 * { code, data: { code, data: { list } } }  ← Dingo 再包一层时
 */
export function pickUsagePayload(res) {
  let cur = res
  for (let i = 0; i < 5 && cur && typeof cur === 'object' && !Array.isArray(cur); i++) {
    if (Array.isArray(cur.list) || cur.item_total != null || cur.summary_30d != null) {
      return cur
    }
    if (cur.data != null && typeof cur.data === 'object' && !Array.isArray(cur.data)) {
      cur = cur.data
      continue
    }
    break
  }
  return cur && typeof cur === 'object' ? cur : null
}

/**
 * GET /idoing_usage — 开放平台消耗明细（登录 Token）
 * @param {{ page?: number, per_page?: number, type?: 'all'|'out'|'in' }} opts
 */
export function fetchOpenGateUsage(opts = {}) {
  const params = {
    page: opts.page || 1,
    per_page: opts.per_page || 20
  }
  if (opts.type && opts.type !== 'all') params.type = opts.type
  return api.get('/idoing_usage', { params })
}
